import { createFileRoute } from "@tanstack/react-router";
import PartsAccountChangePassword from "@/pages/parts-account/PartsAccountChangePassword";

export const Route = createFileRoute("/_partsAuth/parts-catalog/account/change-password")({
  component: PartsAccountChangePassword,
});
